<div class="rd-widget" style="background-color: white;" *ngIf="widgetData">

  <table aria-hidden="true" class="chart-widget-table-container" [style.min-height]="tableContainerHeight">
    <tr>
      <td>
        <div class="layout-buttons-wrapper">
          <div (click)="selectPrevious()" class="prevButton">
            <svg-icon class="navigation-icon" src='./assets/icons/slide_left_right.svg' align='center'></svg-icon>
          </div>
          <div (click)="selectNext()" class="nextButton">
            <svg-icon class="navigation-icon" src='./assets/icons/slide_left_right.svg' align='center'></svg-icon>
          </div>
          <button kendoButton (click)="toggle()" class="widgetButton toggleButton">
            <svg-icon class="navigation-icon" src='./assets/icons/switch.svg' align='center'></svg-icon>
          </button>
          <div class="dashboardHandle"></div>
          <div class="widget-title">
            {{currentLayout | uppercase}} &nbsp;
          </div>
        </div>
      </td>
    </tr>
    <tr>
      <td class="chart-table-wrapper">

        <div *ngIf="!displayTableData" class="k-donut-chart-container-print-fix">
          <div class="k-donut-chart-wrapper">
            <kendo-chart class="k-donut-chart-area" (render)="onRender($event)">
              <kendo-chart-area background="none"></kendo-chart-area>

              <ng-template kendoChartDonutCenterTemplate>
                <h3 [style.fontSize]="(textScale*30) + 'px'">
                  {{ widgetData.displayValue | number:'1.0-0'}} {{unitOfLength}}²
                </h3>
                <p [style.fontSize]="(textScale*18) + 'px'">
                  {{'widgets.portfolioLettableAreaPropertyType.lettableArea' | translate}}
                </p>
              </ng-template>

              <kendo-chart-series>
                <kendo-chart-series-item type="donut" [data]="widgetData.entries" categoryField="label" field="value"
                                         [color]="getColor" [size]="(donutHoleScale*30)" [holeSize]="(donutHoleScale*120)" [autoFit]="true">
                  <kendo-chart-series-item-labels position="outsideEnd" color="#000" [content]="labelContent">
                  </kendo-chart-series-item-labels>
                </kendo-chart-series-item>
              </kendo-chart-series>

              <kendo-chart-legend [visible]="false"></kendo-chart-legend>
            </kendo-chart>
          </div>
        </div>

        <table *ngIf="displayTableData" class="widget-large widgetNoTopBorder widget-table-data" aria-hidden="true">
          <tbody>
            <tr>
              <td colspan="6" class="widget-column-header">
                {{'widgets.portfolioLettableAreaPropertyType.propertyType' | translate}}
              </td>
              <td colspan="6" class="widget-column-header">
                {{'widgets.portfolioLettableAreaPropertyType.lettableArea' | translate}} {{unitOfLength}}²
              </td>
              <td colspan="6" class="widget-column-header">
                {{'widgets.portfolioLettableAreaPropertyType.percent' | translate}}
              </td>
            </tr>
            <tr *ngFor="let entry of widgetData.entries" class="content-row">
              <td colspan="6" class="widget-column-value"> {{ entry.label}} </td>
              <td colspan="6" class="widget-column-value"> {{ entry.displayValue | number:'1.0-2'}} </td>
              <td colspan="6" class="widget-column-value "> {{ entry.value}}% </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td colspan="6" class="widget-column-value widget-column-total" style="font-weight: bold;">
                {{'widgets.portfolioLettableAreaPropertyType.total' | translate }}
              </td>
              <td colspan="6" class="widget-column-value widget-column-total" style="font-weight: bold;">
                {{
              widgetData.displayValue | number:'1.0-2'
                }}
              </td>
              <td colspan="6" class="widget-column-value widget-column-total" style="font-weight: bold;">
                {{
              widgetData.value
                }}%
              </td>
            </tr>
            <tr>
              <td colspan="16">&nbsp;</td>
            </tr>
          </tfoot>
        </table>

      </td>
    </tr>
  </table>

</div>
